import { FormFieldGroup, FormImageUpload, FormInput, FormLabel } from '$components'
import { Input, useEditPetProfileForm } from './index'

export function EditPetProfileContent() {
  const { fileHandler } = useEditPetProfileForm()

  return (
    <div className="flex flex-col gap-stack-section flex-grow">
      <div className="flex sm:flex-row flex-col gap-stack-section">
        <FormFieldGroup className="w-fit">
          <FormLabel htmlFor={Input.Image}>
            Pet Photo
          </FormLabel>

          <FormImageUpload
            name={Input.Image}
            rounding="full"
            onChange={(file) => fileHandler.uploadFile(Input.Image, file)}
          />
        </FormFieldGroup>

        <FormFieldGroup>
          <FormLabel htmlFor={Input.Name}>
            Pet Name
          </FormLabel>

          <FormInput
            name={Input.Name}
            placeholder="Enter pet name..."
          />
        </FormFieldGroup>
      </div>
    </div>
  )
}
